module.exports = __webpack_public_path__ + "static/media/1.5d93e8fd.jpg";